import { atom } from "jotai";

export const showZslFeedbackAtom = atom(false);
showZslFeedbackAtom.debugLabel = "showZslFeedbackAtom";
